// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2hqOa","subheader":"ReorderModal_subheader__3zGbx","listWrap":"ReorderModal_listWrap__2xKw-"};